import { analytics } from '@/shared/services/analytics'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import posthog from 'posthog-js'

export enum FeatureFlag {
  AI = 'ai',
  Origin = 'origin',
}

export const useFeatureFlagStore = defineStore('featureFlags', () => {
  const flagsLoaded = ref(false)
  const flags = ref<Record<string, boolean>>({})

  let resolveFlags: (() => void) | null = null
  const flagsReadyPromise = new Promise<void>((resolve) => {
    resolveFlags = resolve
  })

  const hasPostHog = !!import.meta.env.VITE_POSTHOG_KEY

  const init = () => {
    if (!hasPostHog) {
      flagsLoaded.value = true
      resolveFlags?.()
      return
    }

    posthog.onFeatureFlags((featureFlags) => {
      const updated: Record<string, boolean> = {}
      for (const flag of featureFlags) {
        updated[flag] = true
      }
      flags.value = updated
      flagsLoaded.value = true
      resolveFlags?.()
    })
  }

  const isEnabled = (flag: FeatureFlag): boolean => {
    if (!hasPostHog) return true
    if (!flagsLoaded.value) return false
    return !!flags.value[flag]
  }

  const useFlag = (flag: FeatureFlag) => {
    return computed(() => isEnabled(flag))
  }

  const waitForFlags = (): Promise<void> => {
    if (!hasPostHog) return Promise.resolve()
    return flagsReadyPromise
  }

  return {
    flagsLoaded,
    init,
    isEnabled,
    useFlag,
    waitForFlags,
  }
})
